export default {
    attributes: {
        firstname: 'voornaam',
        surname: 'achternaam',
        zipcode: 'postcode',
        house_num: 'huisnummer',
        house_num_add: 'huisnummer toevoeging',
        telephone: 'telefoonnummer',
        emailaddress: 'e-mailadres'
    }
};



// WEBPACK FOOTER //
// ./src/app/i18n/nl.js